import * as React from "react";
import "./Sidebar.css";

interface IState {
  timerId: number | undefined;
  date: string;
}

class Sidebar extends React.Component<{}, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      date: "",
      timerId: undefined
    };
  }

  public componentDidMount() {
    // const timerId = window.setInterval(() => {
    //     this.setState({date: `${new Date().toLocaleDateString()} - ${new Date().toLocaleTimeString()}`})
    // }, 1000)
    // this.setState({ timerId })
  }

  public componentWillUnmount() {
    // clearInterval(this.state.timerId)
    // this.setState({timerId: undefined})
  }

  public render() {
    return (
      <div className="sidebar">
        {this.props.children}
        <div className="footer">{this.state.date}</div>
      </div>
    );
  }
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/sidebar/index.tsx